import { ObjectFieldTemplateProps } from "@rjsf/utils";

function DocumentsTemplate(props: ObjectFieldTemplateProps, func: any) {
  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="property-wrapper">
            {func("document", props)?.content}
          </div>
        </div>
        <div className="col-12">
          <div className="property-wrapper">
            {func("name", props)?.content}
          </div>
        </div>        
      </div>
    </>
  );
}

export default DocumentsTemplate;
